import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

export class OperationIdAction {

  private _id: string | null = null;

  constructor(private readonly _generate: () => string) {}

  get id(): string {
    if (!this._id) {
      this._id = this._generate();
    }
    return this._id;
  }

  complete(): void {
    this._id = null;
  }
}

@Injectable({
  providedIn: 'root'
})
export class OperationIdService {

  begin(): string {
    return uuidv4();
  }

  action(): OperationIdAction {
    return new OperationIdAction(() => this.begin());
  }
}
